import { connect } from 'react-redux';
import { AnyAction } from 'redux';

import { isFeatureEnabled } from '../../../helpers/featureFlags';
import trackABExperiment from '../../../helpers/trackABExperiment';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';

import ExerciseCompleted from './ExerciseCompleted';

const mapStateToProps = (state: any) => {
  const canRateChapter = selectors.selectCanRateChapter(state);
  const shouldSeeExerciseRating = selectors.selectShouldSeeExerciseRating(
    state,
  );

  // hide for last exercise of LTI exams
  const shouldSeeContinueButton = !(
    selectors.selectIsReducedOutlineCourse(state) &&
    selectors.selectExerciseIndex(state) + 1 ===
      selectors.selectCurrentChapterNbExercises(state)
  );

  return {
    userId: selectors.selectUserSettings(state).get('id'),
    courseId: selectors.selectCourse(state).get('id'),
    nextExPath: selectors.selectNeighborsExercises(state).nextExercise,
    userProgress: selectors.selectGlobalUserProgress(state),
    imageUrl: selectors.selectCourseImageURL(state),
    ltiStatus: selectors.selectUserExercise(state).toJS().ltiStatus,
    canRateChapter,
    shouldSeeExerciseRating,
    window: selectors.selectChapterWindow(state).toJS(),
    shouldSeeContinueButton,
    isNavigatingToNextExercise: selectors.selectIsNavigatingToNextExercise(
      state,
    ),
    xpWon: selectors.selectCurrentExerciseXpWon(state),
  };
};

const mapDispatchToProps = (dispatch: any) => {
  const isOn = isFeatureEnabled('wl--streaks-communication');
  const wrapWithDailyStreak = (action: AnyAction) => {
    return dispatch(
      isOn ? actions.checkDailyStreak({ nextStep: action }) : action,
    );
  };

  const submitExerciseRating = (nextPath: any) => (
    rating: any,
    feedback: any,
  ) => {
    wrapWithDailyStreak(
      actions.epicSubmitExerciseRating({
        extraInfo: feedback,
        rating,
        nextPath,
      }),
    );
  };

  return {
    onClose: ({ id }: any) =>
      wrapWithDailyStreak(actions.hideCompletedExercise({ id })),
    submitRating: submitExerciseRating, // TODO: double check this
    showWindow: () => wrapWithDailyStreak(actions.showWindow({ show: true })),
    onFirstTimeCompletedChapters: () =>
      wrapWithDailyStreak(actions.firstTimeCompletedChapters()),
    onNext: (event: any) => {
      event.preventDefault();
      wrapWithDailyStreak(actions.nextInternalExercise());
    },
    showChapterRating: (courseId: any, userId: any) => {
      const bucket = trackABExperiment('skipChapterRating', courseId, userId);
      if (bucket === 'control') {
        return dispatch(
          actions.showModal({
            modal: {
              ...selectors.MODAL_TYPE.CHAPTER_RATING,
              onFinish: () => {
                wrapWithDailyStreak(actions.nextInternalExercise());
                dispatch(actions.removeModal());
              },
            },
          }),
        );
      }
      return wrapWithDailyStreak(actions.nextInternalExercise());
    },
  };
};

const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  showChapterRating: () =>
    dispatchProps.showChapterRating(stateProps.courseId, stateProps.userId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ExerciseCompleted);
